export default __webpack_public_path__ + "static/media/radiobutton_inactive.092f187c.svg";